<template>
  <div class="container">
    <div class="container" v-if="loading">
      <div class="row">
        <div class="loading-sm"></div>
      </div>
    </div>
    <div v-else class="card" :key="componentKey">
      <h6 style="margin-left:5px;"><b>Business</b> - Transactions</h6>
            <div class="card card-flat-pad">
                <div>
                    <div style="width: 100%"><b>Today</b></div>
                    <div style="margin:1em; text-align: center;">
                        <div style="float:left; width:30%">
                            <span style="font-size:16px;">{{sellpoint_transactions.transactions_total_today}}</span> <br>
                            <span style="font-size:12px;">Total Transactions</span> 
                        </div>
                        <!-- <div style="width:10%"> |
                        </div> -->
                        <div style="float:right;width:45%">
                            <span style="font-size:16px;">NGN{{sellpoint_transactions.transactions_total_today_amount}}</span> <br>
                            <span style="font-size:12px;">Total Amount Received</span>
                        </div>
                        <div style="clear:both;"></div>
                    </div>
                </div>
                <div>
                    <div style="width: 100%"><b>Total</b></div>
                    <div style="margin:1em; text-align: center;">
                        <div style="float:left; width:30%">
                            <span style="font-size:16px;">{{sellpoint_transactions.transactions_total}}</span> <br>
                            <span style="font-size:12px;">Total Transactions</span> 
                        </div>
                        <!-- <div style="width:10%"> |
                        </div> -->
                        <div style="float:right;width:45%">
                            <span style="font-size:16px;">NGN{{sellpoint_transactions.transactions_total_amount}}</span> <br>
                            <span style="font-size:12px;">Total Amount Received</span>
                        </div>
                        <div style="clear:both;"></div>
                    </div>
                </div>
            </div>
            <div class="card card-flat-pad">
                        <p>{{sellpoint_transactions.transactions_total}} Transactions</p>
                        <div class="">
                          <div class="card card-flat-pad" v-for="(tx,tdex) in sellpoint_transactions.transactions" :key="tx.transaction_id">
                            <div style="float:left; width:90%;">
                              <div>
                                <span style="float:left; width: 55%;"><b>{{tx.transaction_user_name}}</b></span>
                                <span style="float:right; width: 35%;">  &#8358;{{tx.transaction_amount_paid}}</span>
                                <div style="clear:both;"></div>
                              </div>
                              
                            </div>
                            <div style="float:right;">
                              <div>
                                <a v-if="menu_tab_inner_view['TX'+tdex]" style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('')">
                                  <div class="">
                                    <i class="fa fa-angle-down"></i>
                                  </div>
                                </a>
                                <a v-else style="cursor:pointer; color: inherit;" @click="setMenuTabInnerView('TX'+tdex)">
                                  <div class="">
                                    <i class="fa fa-angle-down"></i>
                                  </div>
                                </a>
                              </div>
                            </div>
                            <div style="clear: both;"></div>
                            <div v-if="menu_tab_inner_view['TX'+tdex]">
                              <div class="orders-panel" style="margin-top:1em;">
                                <p style="text-align:center; font-weight:bolder; font-size:18px;"> . . .</p>
                                <div class="card card-strip">
                                  <div class="card-left-50">
                                    <p>Payment from</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>{{tx.transaction_user_name}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div class="card card-strip"  >
                                  <div class="card-left-50">
                                    <p>Details</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>{{tx.transaction_details}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div class="card card-strip" >
                                  <div class="card-left-50">
                                    <p>Type of Payment</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>{{tx.transaction_type_name}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div class="card card-strip">
                                  <div class="card-left-50">
                                    <p>Payment Ref</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>{{tx.transaction_payment_ref}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div class="card card-strip" >
                                  <div class="card-left-50">
                                    <p>Date</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>{{tx.transaction_payment_date}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div class="card card-strip" v-if="tx.transaction_transaction_type != 4"><!--not-for-delivery-partner-->
                                  <div class="card-left-50">
                                    <p>Amount Paid</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>&#8358;{{tx.transaction_total_amount_paid}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div class="card card-strip">
                                  <div class="card-left-50">
                                    <p>Amount Received</p>
                                  </div>
                                  <div class="card-right-50">
                                    <p>&#8358;{{tx.transaction_amount_paid}}</p>
                                  </div>
                                  <div class="clearfix"></div>
                                </div>
                                <div v-if="tx.transaction_transaction_type != 4"><!--not-for-delivery-partner-->
                                  <div class="card card-strip" v-if="(tx.transaction_payment_settlements && (Object.keys(tx.transaction_payment_settlements).length !== 0))">
                                    <p><u>Payment Settlements</u></p>
                                    <div v-if="sellpoint.business_agent == 1">
                                        <div v-for="txs in tx.transaction_payment_settlements" :key="txs.payment_stl_id">
                                            <div v-if="txs.payment_stl_type == 22">
                                                <div class="card-left-50">
                                                    <p><span style="color:#7a7878"><b>{{txs.payment_stl_type_name}}</b></span></p>
                                                </div>
                                                <div class="card-right-50">
                                                    <p>
                                                    <span v-if="txs.payment_stl_payment_name != ''">{{txs.payment_stl_payment_name}}<br></span>NGN{{txs.payment_stl_amount}}
                                                    </p>
                                                </div>
                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                      <div v-for="txs in tx.transaction_payment_settlements"  :key="txs.payment_stl_id">
                                        <div class="card-left-50">
                                          <p><span style="color:#7a7878"><b>{{txs.payment_stl_type_name}}</b></span></p>
                                        </div>
                                        <div class="card-right-50">
                                          <p>
                                            <span v-if="txs.payment_stl_payment_name != ''">{{txs.payment_stl_payment_name}}<br></span>NGN{{txs.payment_stl_amount}}
                                          </p>
                                        </div>
                                        <div class="clearfix"></div>
                                      </div>
                                    </div>
                                    <div class="clearfix"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
  </div>
</template>

<style>

</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {}
        },

        methods: {
            setPage(){
              this.loading = true;
              //get transactions
              this.getAppBusinessTransactions(); 
            },
        },

        components: {},

        created: function(){
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                    self.setPage();
                }else{}
            });
        }

    }
</script>



// WEBPACK FOOTER //
// SellpointTransactions.vue?38071da1